import { msg } from "@lingui/core/macro";

export const maxTimePerCodeInPeriodRuleMessages = {
	name: msg({
		message: "Maximum Time Per Code",
		comment: "Name of the rule limiting total parking time shared by everyone using one registration code",
	}),
	description: msg({
		message: "Maximum Parking Time Per Code in a Period of Time",
		comment: "Describes the rule limiting total parking time shared by everyone using one registration code",
	}),
	errors: {
		limitReached: msg({
			message: "The {period} limit of {duration} of parking time for this code has been reached.",
			comment:
				"Shown when the pool of parking time shared by everyone using one registration code is used up. Distinguish from the per-vehicle limit of the same shape",
		}),
	},
} as const;
